import { useState } from 'react';
import { Box, Button } from '@material-ui/core';
import themes from 'styles/themes';
import { useStyles } from './styles';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import NavigationBottom from 'component/navigation/navigation_bottom_home';
import NavigationBottomStylist from 'component/navigation/navigation_bottom_stylist';
import UserType from 'constants/user';
import { PATH } from 'routes/constant';
import { useLocation } from 'react-router-dom';
import { UserQuizStatus } from 'containers/quiz_manager';
import ProgressBar from 'component/progress_bar';
import { QuizSpinner } from './quiz-spinner';
import { EQuizId } from 'types/quiz';
import SkipQuiz from 'component/skip_quiz';
import { QuizSkipModal } from './quiz_skip_modal';
import utils from 'utils/utils';
import { STRINGS } from '../../constants/strings';

interface ILayoutQuiz {
    quizId: EQuizId;
    handleAnswer: () => void;
    title: string;
    children?: Element | any;
    isUpdate: boolean;
    isDisplayContent: boolean;
    titlePage: string;
    hideBottomNav?: boolean;
    isHiddenAction?: boolean;
    requiredQuestion?: boolean;
    hideContinue?: boolean;
    handleSkipQuestion?: () => void;
    loading?: boolean;
    loadingSkip?: boolean;
    nextBtnDisabled?: boolean;
    submitButtonCustomText?: string;
    containerLoading?: boolean;
    completeQuizProcess?: () => void;
}
const CustomizeLayoutQuiz = ({
    quizId,
    handleAnswer,
    title,
    isUpdate,
    isDisplayContent,
    titlePage,
    hideBottomNav,
    isHiddenAction,
    requiredQuestion,
    handleSkipQuestion,
    hideContinue = false,
    loading,
    loadingSkip,
    submitButtonCustomText,
    nextBtnDisabled,
    containerLoading,
    completeQuizProcess,
    ...props
}: ILayoutQuiz) => {
    const classes = useStyles();
    const location = useLocation();
    const user = useSelector((state: RootState) => state.userDetail.me);
    const isUpdatePage = location.pathname.includes(PATH.MY_STYLE_PREFERENCES);
    const pendingQuizObj = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const userQuizzes =
        pendingQuizObj?.hasOwnProperty('getPendingQuizzes') && pendingQuizObj?.getPendingQuizzes?.quizConfigs;
    const pendingQuizzes = userQuizzes && userQuizzes?.filter((item) => item.status === UserQuizStatus.pending);
    const withGenderQuizLength = userQuizzes.length + 1;
    const completedQuizPercentage = ((withGenderQuizLength - pendingQuizzes.length) / withGenderQuizLength) * 100;
    const [isSkipOpen, setIsSkipOpen] = useState(false);

    const handleSkipClose = () => {
        setIsSkipOpen(false);
    };
    const handleSkipOpen = () => {
        setIsSkipOpen(true);
    };

    return (
        <Box
            // hideBottomNav={hideBottomNav}
            height={'100%'}
            display={'flex'}
            flexDirection={'column'}
            className={'quiz-parent-layout'}
            style={{
                background: themes.palette.primary.light,
            }}
        >
            <Box width={'100%'} height="100%" display={'flex'} flexDirection={'column'}>
                {titlePage && !isUpdatePage && (
                    <div
                        className={classes.titleContainer}
                        style={{
                            marginTop: utils.isAppInWidgetMode() ? '35px' : '0px',
                        }}
                    >
                        <div className={classes.titleSkipContainer} />
                        <p
                            className={classes.titlePage}
                            style={{
                                fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
                            }}
                        >
                            {titlePage}
                        </p>
                        <div className={classes.titleSkipContainer}>
                            <SkipQuiz quizId={quizId} handleSkipOpen={handleSkipOpen} />
                        </div>
                    </div>
                )}
                {location.pathname.includes(PATH.QUIZ_MANAGER) && (
                    <ProgressBar completedPercentage={completedQuizPercentage} />
                )}
                {isDisplayContent && title && (
                    <Box
                        textAlign={'center'}
                        pt={1}
                        pb={1}
                        px={2}
                        maxHeight={225}
                        display="flex"
                        alignItems={'center'}
                        justifyContent="center"
                        mt={location.pathname.includes(PATH.QUIZ_MANAGER) ? 2 : 0}
                    >
                        <div className={classes.subTitle} dangerouslySetInnerHTML={{ __html: title }}></div>
                    </Box>
                )}
                <Box className={classes.quizContainer}>
                    {containerLoading && <QuizSpinner />}
                    {props.children}
                </Box>
                {!isHiddenAction ? (
                    <Box className={classes.continueContainer}>
                        <Box className={classes.continue} style={{ zIndex: 100 }}>
                            {isDisplayContent && (
                                <Box width={'100%'} maxWidth={330}>
                                    {hideContinue ? null : (
                                        <button
                                            type="submit"
                                            className={classes.button}
                                            style={{
                                                color: themes.palette.common.white,
                                                backgroundColor: !nextBtnDisabled
                                                    ? themes.palette.primary.main
                                                    : '#A3A3A3',
                                            }}
                                            onClick={handleAnswer}
                                            disabled={loading || nextBtnDisabled}
                                        >
                                            {submitButtonCustomText
                                                ? submitButtonCustomText
                                                : isUpdate
                                                    ? STRINGS.UPDATE
                                                    : STRINGS.SAVE}{' '}
                                            {loading && (
                                                <Spinner
                                                    animation="border"
                                                    style={{ marginLeft: 10, width: 18, height: 18 }}
                                                />
                                            )}
                                        </button>
                                    )}
                                    {!requiredQuestion && !isUpdate && (
                                        <Button
                                            type="submit"
                                            className={classes.buttonContinue}
                                            onClick={handleSkipQuestion}
                                        >
                                            {STRINGS.RESPOND_LATER}
                                            {loadingSkip && (
                                                <Spinner
                                                    animation="border"
                                                    style={{ marginLeft: 10, width: 18, height: 18 }}
                                                />
                                            )}
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                ) : (
                    <Box minHeight={'65px'}></Box>
                )}
                {!hideBottomNav && !location.pathname.includes(PATH.MY_STYLE_PREFERENCES) ? (
                    <>
                        <div style={{ flex: 1, maxHeight: 56 }}>
                            {!user || user.userType === UserType.Customer ? (
                                <NavigationBottom />
                            ) : (
                                <NavigationBottomStylist />
                            )}
                        </div>
                    </>
                ) : null}
            </Box>
            <QuizSkipModal
                visible={isSkipOpen}
                data={{
                    quizId,
                }}
                onHide={() => {
                    handleSkipClose();
                }}
            />
        </Box>
    );
};
export default CustomizeLayoutQuiz;
